import React, { createRef, useEffect, useMemo, useState } from "react";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import {
    getCrsReportManagers,
    getCrsReportManagersClear,
    getCrsReportOffices,
    getCrsReportRea,
    getCrsReportReaClear,
    getCrsReportStats,
    getCrsReportStatsClear,
    getCrsReportTrend,
    getCrsReportTrendClear,
    getCrsReportTrendOfSingle,
    getCrsReportTrendOfSingleClear,
    getLpManagers,
    getLpManagersClear,
    getLpOffices,
    getLpRea,
    getLpReaClear,
    getLpStats,
    getLpStatsClear,
    getLpTable,
    getLpTableClear,
    getLpTrend,
    getLpTrendClear,
    getLpTrendClearSingle,
    getLpTrendSingle
} from "../../../redux/reports/actions";
import _, { assign } from "lodash";
import ProgressReportTableComponent from "../progressReport/ProgressReportTableComponent";
import Loader from "../../Loader/Loader";
import {
    getAnyTotalReportClear,
    getProfileCompletionReport,
    getProfileCompletionReportClear,
} from "../../../redux/reports/actions";

import CONFIG from "../../../utils/config";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableSectionComp from "../ReportsComponents/ReportTableSectionComp";
import { useLocation, useNavigate } from "react-router-dom";
import ManagerReportSec from "../ReportsComponents/ManagerReportSec";
import OfficeSection from "../ReportsComponents/OfficeSection";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ManagerReportCrs from '../New Progress Report/ManagerReportCrs';
import OfficesReportSection from "../New Progress Report/OfficesReportSection";

import CompletionTrendGraphNew from "../ReportsComponents/CompletionTrendGraphNew";
import DonutChart from "../../Layouts/Graphs/DonutChart";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import ChooseOfficePeople from "../../reportFilter/ChooseOfficePeople";
import ChooseProvider from "../../reportFilter/ChooseProvider";
import ChooseCourse from "../../reportFilter/ChooseCourse";
import ChooseManager from "../../reportFilter/ChooseManager";
import ChooseREA from "../../reportFilter/ChooseREA";
import { getTeamMatesResClear } from "../../../redux/assignCourse/actions";
import TrendChart from "../../../utils/TrendChart";
import TrendChartSingle from "../../../utils/TrendChartSingle";
import ReportGraphComponent from "../layout/ReportGraphComponent";
import ProgressReportTableComponentForAgentDetail from "../progressReport/ProgressReportTableComponentForAgentDetail";
import * as XLSX from "xlsx";
import StaticUtils from "../../../utils/StaticUtils";
import { userDetailOther } from "../../../redux/user/actions";

const LearningPathReportHomeReaDetailSection = (props) => {

    const {
        isMobile
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isCompliance = params.get("isCompliance");
    const idFrom = params.get("id");
    const from = params.get("from");

    const crsOfficesRes = useSelector((state) => state.report?.crsReportOffices);

    const overAllSummaryCrsRes = useSelector(
        (state) => state.report.overallSummaryCrsData
    );
    const [overSummaryCrsData, setOverSummaryCrsData] = useState([]);
    const overAllDataRes = useSelector((state) => state.report.overallData);
    const overAllSummaryGraphRes = useSelector(
        (state) => state.report.overallSummaryCrsGraph
    );
    const [reaList, setReaList] = useState([])
    const [overCrsGraphData, setOverCrsGraphData] = useState([]);
    const [crsCompltTrendData, setCrsCompltTrendData] = useState([]);
    const [overAllData, setOverAllData] = useState([]);
    const [overAllOfficesData, setOverAllOfficesData] = useState([]);
    const [overAllManagersData, setOverAllManagersData] = useState([]);
    const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
    const [overAllLearningHours, setOverAllLearningHours] = useState([]);
    const [OverAllStatsData, setOverAllStatsData] = useState([]);
    const [isView, setIsView] = useState("table");
    const [type, setType] = useState("pie");
    const [canShow, setCanShow] = useState(false);
    const [isLoaded, setIsLoaded] = useState(true);
    const [limitStatus, setLimitStatus] = useState("")
    const [loadSpin, setLoadSpin] = useState(true)
    const [totalRea, setTotalRea] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [imgLoader, setImgLoader] = useState(true);
    const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
    const [crsCompltTrendValuesOfSingle, setCrsCompltTrendValuesOfSingle] = useState([]);
    const [trendFilterCourses, setTrendFilterCourses] = useState([]);
    const [trendFilterCoursesOfSingle, setTrendFilterCoursesOfSingle] = useState([]);
    const [statusFilterData] = useState([
        "Completed",
        "Inprogress",
        "OverDue",
        "Yet to start",
    ]);
    const crsTableRes = useSelector((state) => state.report?.lpTable);
    const crsReaRes = useSelector((state) => state.report?.crsReportRea);
    const crsTrendRes = useSelector((state) => state.report?.crsReportTrend);
    const crsReportTrendOfSingleRes = useSelector((state) => state.report?.crsReportTrendOfSingle);
    const crsStatsRes = useSelector((state) => state.report?.crsReportStats);
    const [profileReports, setProfileReports] = useState(null);
    const [profileReportsFilter, setProfileReportsFilter] = useState([]);
    const [realEstateAgent, setRealEstateAgent] = useState([]);
    const [filterYearData, setFilterYearData] = useState([])
    const [filterYearDataOfSingle, setFilterYearDataOfSingle] = useState([])
    const [legendOfSingle, setLegendOfSingle] = useState([])
    const [seriesOfSingle, setSeriesOfSingle] = useState([])
    const [legendOfAll, setLegendOfAll] = useState([])
    const [seriesOfAll, setSeriesOfAll] = useState([])
    // const [dateRange, setDateRange] = useState({ "start": "", "end": "" })
    const [totalManagers, setTotalManagers] = useState([])
    const profileReportRes = useSelector((state) => state.report.profileReport);
    const d = new Date();
    let year = d.getFullYear();
    const [trendYear, setTrendYear] = useState(year)
    const anyTotalReportRes = useSelector(
        (state) => state.report?.anyTotalReport
    );
    const crsCompletionTrendRes = useSelector(
        (state) => state.report.crsCompletionTrend
    );
    const [currentPage, setCurrentPage] = useState(1);
    const [limitData, setLimitData] = useState();
    const [totalRecord, setTotalRecord] = useState(0);
    const [legends, setLegends] = useState([]);
    const [series, setSeries] = useState([]);
    let PageSize = 20;
    const [counter, setCounter] = useState(1);
    const FILTER_BY = [
        { id: 0, value: "Select" },
        { id: 1, value: "Learning Points" },
        { id: 2, value: "Progress" },
        { id: 3, value: "Learning Hours" },
    ];
    const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
    const [actualCoursesList, setActualCoursesList] = useState([]);
    const [loaderChart, setLoaderChart] = useState(true)
    const [trendLoaderChart, setTrendLoaderChart] = useState(false)
    const [coursesList, setCoursesList] = useState([]);
    const [increment, setIncrement] = useState(1);
    const rea_ids = []
    const manager_ids = []
    const office_ids = []
    const courseList = []
    const providerList = []
    const role=[];
    const status=[];
    const assignmentFrom = [];
    let brokerages = [];
    let user_id = 1;
    let dateRange = {}
    const [selectedOfficeList, setSelectedOfficeList] = useState(
        []
    );
    const [selectedRea] = useState(
        location?.state?.selectedTeamMatesList
    );
    const [selectedCrsList] = useState(
        location?.state?.selectedCourseList)
    const [selectedProviderList, setSelectedProviderList] = useState([])
    const [selectedCourseList, setSelectedCourseList] = useState([])
    const [selectedManagerCoachList, setSelectedManagerCoachList] = useState([])
    const [selectedTeamMatesList, setSelectedTeamMatesList] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(["completed", "in-progress", "overdue", "not-started"])
    const [officeDetail, setOfficeDetail] = useState({});
    const currentObjData = useState(
        location?.state?.currentReportObj)

    const userDetailRes = useSelector(state => state.user.userBroker)
    const userDetailIframe = useSelector(state => state.user.userDetailIframe)
    const [userDetails, setUserDetails] = useState({});

    const [check, setCheck] = useState(isCompliance === "0" ? false : true)
    const [checkCompleted, setCheckCompleted] = useState(true)
    const [checkInProgress, setCheckInProgress] = useState(true)
    const [checkOverdue, setCheckOverdue] = useState(true)
    const [checkYetToStart, setCheckYetToStart] = useState(true)
    const [counterForMng, setCounterForMng] = useState(1);
    const crsManagersRes = useSelector((state) => state.report?.crsReportManagers);

    // new designchanges 1-May-23
    const [isExpand, setIsExpand] = useState(false);
    const lpOfficesRes = useSelector((state) => state?.report?.lpOffices);
    const lpTableRes = useSelector((state) => state.report?.lpTable);
    const lpReaResponse = useSelector((state) => state.report?.lpReaRes);
    const lpTrendRes = useSelector((state) => state.report?.lpTrend);
    const lpTrendResSingle = useSelector((state) => state.report?.lpTrendSingle);
    const lpStatsRes = useSelector((state) => state.report?.lpStats);
    const lpManagersRes = useSelector((state) => state.report?.lpManagers);
    const userOtherRes = useSelector((state) => state.user.userOtherRes);

    useEffect(() => {
        console.log('dateRange: ', dateRange)
    }, [dateRange])

    useEffect(() => {
        console.log('isCompliance: ', isCompliance);
        if (isCompliance === "0") {
            setCheck(false)
        }
    }, [isCompliance])

    useEffect(() => {
        // console.log('userDetailRes: ', userDetailRes)
        if (isMobile) {
            if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
                setUserDetails(userDetailIframe?.payload?.payload)
            }
        } else {
            if (!_.isEmpty(userDetailRes?.payload?.payload)) {
                setUserDetails(userDetailRes?.payload?.payload)
            }
        }
    }, [userDetailRes, userDetailIframe, isMobile])
    useEffect(() => {
        selectedOfficeList.forEach(function (obj) {
            office_ids.push(obj.office_id);
        })
        selectedTeamMatesList.forEach(function (obj) {
            rea_ids.push(obj.user_id);
        })
        selectedManagerCoachList.forEach(function (obj) {
            manager_ids.push(obj.id);
        })
        selectedProviderList.forEach(function (obj) {
            providerList.push(obj.p_id)
        })
        selectedCourseList.forEach(function (obj) {
            if (obj.source === "xsel") {
                courseList.push(obj.course_code)
            } else {
                courseList.push(obj.course_id)
            }
        })
    })

    useEffect(() => {
        setSelectedManagerCoachList([])
    }, [idFrom])

    // COUNT INCREAMENT
    function setCount(counter, setCounter) {
        return setCounter(counter + 1);
    }

    function setCountForManager(counter, setCounterForMng) {
        return setCounterForMng(counter + 1);
    }

    useEffect(() => {
        hitAllFilterApi();
        // setFilterBy(FILTER_BY[0].value);
    }, [dispatch]);
    useEffect(() => {
        // hitReaListApi();
    }, [counter])

    useEffect(() => {
        hitManagerListApi();
    }, [counterForMng])

    useEffect(() => {
        // hitTrendingApi();
        // setFilterBy(FILTER_BY[0].value);
    }, [trendYear]);

    const getStatusArr = () => {
        let statusArr = [];
        if (checkCompleted) {
            statusArr.push('completed');
        }
        if (checkInProgress) {
            statusArr.push('in-progress');
        }
        if (checkOverdue) {
            statusArr.push('overdue');
        }
        if (checkYetToStart) {
            statusArr.push('not-started');
        }
        setSelectedStatus(statusArr)
        return statusArr;
    }

    // const hitReaListApi = () => {
    //   let statusArr = getStatusArr();
    //   dispatch(getLpRea({
    //     module: 'getlPReportRea',
    //     postData: {
    //       token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //       rea_ids: [idFrom],
    //       limit: counter,
    //       office_ids: office_ids,
    //       entity_id: courseList,
    //       is_onboarding: check ? 1 : 0,
    //       manager_ids: manager_ids,
    //       date_range: dateRange,
    //       status: statusArr,
    //     }
    //   }))
    // }

    const hitManagerListApi = (callAPI = true) => {
        if(callAPI) {
            getAppliedFilters()
        }
        dispatch(getLpManagers({
            module: 'getlPReportManagers',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                limit: counterForMng,
                office_ids: office_ids,
                rea_ids: [idFrom],
                entity_id: courseList,
                is_onboarding: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","broker_admin","manager"] : assignmentFrom,
                user_status: user_id,
                brokerage: brokerages

            }
        }))
    }

    const hitOfficeDetailApi = (callAPI = true) => {
        if(callAPI) {
            getAppliedFilters()
        }
        let statusArr = getStatusArr();
        dispatch(getLpOffices({
            module: 'getlPReportOffices',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                rea_ids: [idFrom],
                limit: counter,
                entity_id: courseList,
                // provider_ids: providerList,
                is_onboarding: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","broker_admin","manager"] : assignmentFrom,
                user_status: user_id,
                brokerage: brokerages
            }
        }))
    }

    const hitTrendingApi = () => {
        setTrendLoaderChart(true);
        let statusArr = getStatusArr();
        dispatch(getLpTrend({
            module: 'getlPReportTrend',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                rea_ids: [idFrom],
                entity_id: courseList,
                is_onboarding: check ? 1 : 0,
                year: _.toNumber(trendYear),
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
                ? ["completed", "in-progress", "overdue", "not-started"]
                : status,
              role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
              assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","broker_admin","manager"] : assignmentFrom,
                user_status: user_id,
                brokerage: brokerages
            }
        }))
    }

    const getAppliedFilters = () => {
        let selectedFilters = JSON.parse(localStorage.getItem("SELECTED_FILTER"));
        console.log("selected_fil---",selectedFilters?.selectedFilters);
        let filtersApplied = selectedFilters?.selectedFilters;
        filtersApplied.selectedTeamMatesList.forEach(function (obj) {
          rea_ids.push(obj.user_id);
        });
        filtersApplied.selectedOfficeList.forEach(function (obj) {
            office_ids.push(obj.office_id);
          });
        filtersApplied.selectedManagerCoachList.forEach(function (obj) {
          manager_ids.push(obj.id);
        });
        filtersApplied.selectedProviderList.forEach(function (obj) {
          providerList.push(obj.p_id);
        });
        filtersApplied.selectedCourseList.forEach(function (obj) {
          if (obj.source === "xsel") {
            courseList.push(obj.id);
          } else {
            courseList.push(obj.id);
          }
        });
        if(filtersApplied?.dateRange) {
            dateRange.start = filtersApplied?.dateRange?.start;
            dateRange.end = filtersApplied?.dateRange?.end;
        }
        filtersApplied.selectedStatus.forEach(function (obj) {
          status.push(obj);
        });
        filtersApplied.selectedAssignment.forEach(function (obj) {
            assignmentFrom.push(obj);
          });
        filtersApplied.selectedRole.forEach(function (obj) {
          role.push(obj);
        });
        filtersApplied?.selectedBrokerageList?.forEach(function (obj) {
            brokerages.push(obj);
          });
        user_id=[];
        if (_.isArray(filtersApplied.selectedAgentStatus)) {
          if (filtersApplied.selectedAgentStatus.includes(3) ||
            (filtersApplied.selectedAgentStatus.includes(1) && filtersApplied.selectedAgentStatus.includes(2))
          ) {
            user_id = 3
          } else if (filtersApplied.selectedAgentStatus.includes(1)) {
            user_id = 1
          } else if (filtersApplied.selectedAgentStatus.includes(2)) {
            user_id = 2
          }
        }
    }
    const hitAllFilterApi = () => {
        // ["","in-progress","not-started"],

        getAppliedFilters()
        let statusArr = getStatusArr();
        fetchLPTableReport();

        dispatch(
            userDetailOther({
                module: "getUserDetailOther",
                postData: {
                    user_id: idFrom,
                },
            })
        );


        // hitReaListApi();
        hitManagerListApi(false);

        hitOfficeDetailApi(false);

        // hitTrendingApi();

        // getSingleCompletionTrend(courseList);

        dispatch(getLpStats({
            module: 'getlPReportStats',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                rea_ids: [idFrom],
                entity_id: courseList,
                is_onboarding: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","broker_admin","manager"] : assignmentFrom,
                user_status: user_id,
                brokerage: brokerages

            }
        }))

    }

    const fetchLPTableReport = () => {
        dispatch(
            getLpTable({
                module: "getlPReportTable",
                postData: {
                    token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    limit: counter,
                    rea_ids: [idFrom],
                    entity_id: courseList,  //course_codes
                    office_ids: office_ids,
                    // provider_ids: providerList,
                    is_onboarding: check ? 1 : 0,
                    manager_ids: manager_ids,
                    date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                    status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","broker_admin","manager"] : assignmentFrom,
                    user_status: user_id,
                    brokerage: brokerages,
                    fetchDetail: false
                },
            })
        );
        // setTimeout(() => {
        //     dispatch(
        //         getLpTable({
        //             module: "getlPReportTable",
        //             postData: {
        //                 token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //                 limit: counter,
        //                 rea_ids: [idFrom],
        //                 entity_id: courseList,  //course_codes
        //                 office_ids: office_ids,
        //                 provider_ids: providerList,
        //                 is_onboarding: check ? 1 : 0,
        //                 manager_ids: manager_ids,
        //                 date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
        //                 status: _.isEmpty(status)
        //         ? ["completed", "in-progress", "overdue", "not-started"]
        //         : status,
        //       role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
        //                 user_status: user_id,
        //                 brokerage: brokerages,
        //                 fetchDetail: true
        //             },
        //         })
        //     );
        // }, 4000)
    }

    const getSingleCompletionTrend = (courseList) => {
        setIsLoading(true)
        setLoaderChart(true)
        let statusArr = getStatusArr();
        dispatch(getLpTrendSingle({
            module: 'getlPReportTrend',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                entity_id: courseList,
                rea_ids: [idFrom],
                is_onboarding: check ? 1 : 0,
                year: _.toNumber(trendYear),
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","broker_admin","manager"] : assignmentFrom,
                user_status: user_id,
                brokerage: brokerages
            }
        }))
    }

    // useEffect(() => {
    //   if (!_.isEmpty(lpOfficesRes)) {

    //     if (lpOfficesRes?.status === "success") {
    //       let allData = (lpOfficesRes?.payload?.payload?.offices);

    //       if (allData?.length > 0)
    //         setOfficeDetail(allData[0])

    //     }
    //   }
    // }, [lpOfficesRes])

    useEffect(() => {
        console.log('userOtherRes: ', userOtherRes)

        if (!_.isEmpty(userOtherRes)) {
            if (userOtherRes.status === "success") {
                setOfficeDetail(userOtherRes?.payload?.payload)
            }
        }

    }, [userOtherRes])

    const searchTable = (searchVal) => {
        let list = _.cloneDeep(profileReportsFilter);
        if (searchVal === "") { setProfileReports(list); return; }

        let filterBySearch = [];
        for (const item of list) {
            if (
                item?.lp_name?.toLowerCase().includes(searchVal.toLowerCase())) {
                filterBySearch.push(item)
            }
        }
        console.log('filterBySearch: ', filterBySearch);

        setProfileReports(filterBySearch);
    }

    //LP Table
    useEffect(() => {
        if (!_.isEmpty(lpTableRes)) {
            setIsLoaded(false);
            if (lpTableRes?.status === "success") {
                setIsLoading(false);
                let legends = [];
                let series = [];
                const reportData = lpTableRes?.payload?.payload?.user_data;
                setProfileReports(reportData);
                setProfileReportsFilter(reportData)
                if (statusFilterData.includes("completed")) {
                    let completedCount = reportData.filter((data) => data.status === "completed").length;
                    series.push(
                        reportData.filter((data) => data.status === "completed").length
                    );
                    legends.push(`Completed (${completedCount})`);
                }
                if (statusFilterData.includes("in-progress")) {
                    let inprogressCount = reportData.filter((data) => data.status === "in-progress").length
                    series.push(
                        reportData.filter((data) => data.status === "in-progress").length
                    );
                    legends.push(`In Progress(${inprogressCount})`);
                }
                if (statusFilterData.includes("overdue")) {
                    let overdueCount = reportData.filter((data) => data.status === "overdue").length
                    series.push(
                        reportData.filter((data) => data.status === "overdue").length
                    );
                    legends.push(`Overdue(${overdueCount})`);
                }
                if (statusFilterData.includes("not-started")) {
                    let notStartedCount = reportData.filter((data) => data.status === "not-started").length;
                    series.push(
                        reportData.filter((data) => data.status === "not-started").length
                    );
                    legends.push(`Yet to start (${notStartedCount})`);
                }
                if (legends.length < 4) {
                    legends.push("Others");
                    series.push(totalRecord - _.sum(series));
                }
                setLegends(legends);
                setSeries(series);
                setCurrentPage(1);

            } else {
                setProfileReports([]);
                setCanShow(false);
                setIsLoading(false);
            }

            dispatch(getLpTableClear());

        }
    }, [lpTableRes])

    useEffect(() => {
        if (!_.isEmpty(anyTotalReportRes)) {
            if (anyTotalReportRes.status === "success") {
                setTotalRecord(anyTotalReportRes.payload.payload.length);
            }
            return () => {
                dispatch(getAnyTotalReportClear());
            };
        }
    }, [anyTotalReportRes]);


    useEffect(() => {
        dispatch(
            getCrsReportStatsClear());
    }, [dispatch])

    useEffect(() => {
        setCounter(1)
        setRealEstateAgent([])
        return (() => {
            dispatch(getCrsReportReaClear())
        })
    }, [])
    //LP Rea
    useEffect(() => {
        if (!_.isEmpty(lpReaResponse)) {
            setLoadSpin(false)
            if (lpReaResponse?.status === "success") {
                let allData = [];
                allData = sortByAlphabetical(lpReaResponse?.payload?.payload?.real_estate_agents);
                let realEstateAgents = lpReaResponse?.payload?.payload?.real_estate_agents;
                setTotalRea(lpReaResponse?.payload?.payload)
                let temparr = _.cloneDeep(realEstateAgent)
                if (counter === 1) {
                    temparr = []
                }
                setReaList([...temparr, ...allData])
                setLimitStatus(lpReaResponse?.payload?.payload?.real_estate_agents)
                setRealEstateAgent([...temparr, ...allData]);
                setActualCoursesList([...temparr, ...allData]);
                dispatch(getLpReaClear())
            }
        }
    }, [lpReaResponse])

    useEffect(() => {
        return (() => {
            dispatch(getCrsReportTrendClear())
        })
    }, [])
    //Compliance Completion trend
    useEffect(() => {
        if (!_.isEmpty(lpTrendRes)) {
            if (lpTrendRes?.status === "success") {
                setImgLoader(false)
                setLoaderChart(false)
                setTrendLoaderChart(false)
                let allData = []
                allData = lpTrendRes?.payload?.payload?.completion_trend;
                let trendData = Object.entries(allData) //Object.values(allData)
                let tempArrTrend = [['', 'Percentage']]

                for (const [key, value] of trendData) {
                    tempArrTrend.push([key, value])
                }
                setCrsCompltTrendValues(tempArrTrend)

                // setCrsCompltTrendValues(Object.values(allData));
                setFilterYearData(lpTrendRes?.payload?.payload?.year)
                setTrendFilterCourses(lpTrendRes?.payload?.payload?.learningPath)

                let tempArr = [];
                let tempArrSeries = [];
                let legend = lpTrendRes?.payload?.payload?.legends_data;
                tempArr.push(`Completed (${legend?.completed})`);
                tempArrSeries.push(legend?.completed)
                tempArr.push(`In Progress(${legend?.inprogress})`);
                tempArrSeries.push(legend?.inprogress)
                tempArr.push(`Overdue(${legend?.overdue})`);
                tempArrSeries.push(legend?.overdue)
                tempArr.push(`Yet to start (${legend?.notstarted})`);
                tempArrSeries.push(legend?.notstarted)
                setLegendOfAll(tempArr)
                console.log('tempArrSeries', tempArrSeries)
                setSeriesOfAll(tempArrSeries)


                dispatch(getLpTrendClear())
            }

        }
    }, [lpTrendRes])

    useEffect(() => {
        if (!_.isEmpty(lpTrendResSingle)) {
            setImgLoader(false);
            setIsLoading(false);
            setLoaderChart(false)
            if (lpTrendResSingle?.status === "success") {
                let allData = []
                allData = lpTrendResSingle?.payload?.payload?.completion_trend;
                let trendData = Object.entries(allData) //Object.values(allData)
                let tempArrTrend = [['', 'Percentage']]

                for (const [key, value] of trendData) {
                    tempArrTrend.push([key, value])
                }
                // setCrsCompltTrendValuesOfSingle(tempArrTrend)
                setCrsCompltTrendValuesOfSingle(Object.values(allData));
                setFilterYearDataOfSingle(lpTrendResSingle?.payload?.payload?.year)

                let tempArr = [];
                let tempArrSeries = [];
                let legend = lpTrendResSingle?.payload?.payload?.legends_data;
                tempArr.push(`Completed (${legend?.completed})`);
                tempArrSeries.push(legend?.completed)
                tempArr.push(`In Progress(${legend?.inprogress})`);
                tempArrSeries.push(legend?.inprogress)
                tempArr.push(`Overdue(${legend?.overdue})`);
                tempArrSeries.push(legend?.overdue)
                tempArr.push(`Yet to start (${legend?.notstarted})`);
                tempArrSeries.push(legend?.notstarted)

                setLegendOfSingle(tempArr)
                setSeriesOfSingle(tempArrSeries)
                dispatch(getLpTrendClearSingle())
            }
        }
    }, [lpTrendResSingle])

    //LP Stats
    useEffect(() => {
        if (!_.isEmpty(lpStatsRes)) {
            if (lpStatsRes?.status === "success") {
                setIsLoaded(false);
                let allData = lpStatsRes?.payload?.payload?.stats;
                setOverAllLearningPoints(allData)
            }
            dispatch(getLpStatsClear())
        }
    }, [lpStatsRes])

    const currentTableData = useMemo(() => {
        if (profileReports !== null) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            setCanShow(true);
            return profileReports?.slice(firstPageIndex, lastPageIndex);
        }
    }, [currentPage, profileReports]);
    // let min = Math.ceil(overAllLearningPoints?.learning_mins * 60);
    // filtration
    const sortByAlphabetical = (list) => {
        return list?.sort((a, b) => b.learning_points - a.learning_points);
    };
    const sortByProgress = (list) => {
        return list?.sort(
            (a, b) =>
                _.toNumber(b.learning_percentage) - _.toNumber(a.learning_percentage)
        );
    };
    const sortByLearningHrs = (list) => {
        return list?.sort(
            (a, b) => _.toNumber(b.learning_hrs) - _.toNumber(a.learning_hrs)
        );
    };

    // useEffect(() => {
    //   if (counter > 1)
    //     sortAfterLoadMore();
    // }, [actualCoursesList])

    const sortAfterLoadMore = () => {
        if (filterBy === "Learning Points") {
            const sortedList = sortByAlphabetical(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else if (filterBy === "Progress") {
            const sortedList = sortByProgress(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else if (filterBy === "Learning Hours") {
            const sortedList = sortByLearningHrs(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else {
            setRealEstateAgent(reaList)
        }
    };

    const ExportToExcel = () => {
        const data = _.cloneDeep(profileReports);
        for (let item of data) {
            item.profile_status =
                item?.profile_status === "Inprogress"
                    ? "In Progress"
                    : item?.profile_status === "Yet to start" || item?.profile_status === "not-started"
                        ? "Yet to start"
                        : item?.profile_status === "OverDue"
                            ? "Overdue"
                            : "Completed";
            item.profile_progress =
                item?.profile_progress !== undefined && item?.profile_progress !== ""
                    ? item?.profile_progress + "%"
                    : "-";
            item.complete_date =
                item?.complete_date !== undefined && item?.complete_date !== ""
                    ? moment(
                        StaticUtils.getDateFromTimeStamp(item?.complete_date),
                        "MM/DD/YYYY"
                    ).format("DD MMM, YYYY")
                    : "-";
        }

        //for sequencing
        let tempArr = [];
        for (const item of data) {
            let obj = {
                "first_name": item.first_name,
                "last_name": item.last_name,
                "email": item.email,
                "user_manager_name": item.user_manager_name,
                "ofc_location": item.ofc_location,
                "office_name": item.office_name,
                "lp_name": item.lp_name,
                "profile_status": item.profile_status,
                "profile_progress": item.profile_progress,
                "complete_date": item.complete_date,
            }
            tempArr.push(obj)

        }


        const newThing = [];
        tempArr.map((item) => {
            newThing.push(
                _.mapKeys(item, (value, key) => {
                    switch (key) {
                        case "first_name":
                            return "First Name";
                        case "last_name":
                            return "Last Name";
                        case "email":
                            return "Email";
                        case "user_manager_name":
                            return "Reports to";
                        case "ofc_location":
                            return "Location";
                        case "lp_name":
                            return check ? "Onboarding" : "Learning Path";
                        case "profile_status":
                            return "Status";
                        case "profile_progress":
                            return "Progress %";
                        default:
                            return;
                    }
                })
            );
        });

        for (let i = 0; i < newThing.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete newThing[i].undefined;
        }

        for (let i = 0; i < data.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete data[i]._id;
        }
        // console.log('data:', data)
        // exportFromJSON({ data, fileName, exportType })

        //For mobile
        let tempObj = {
            method: check ? "Onboarding_Report" : "Learning_Path_Report",
            report: newThing
        }
        if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(JSON.stringify(tempObj));
        } else if (window.webkit != undefined) {
            if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(tempObj));
            }
        }



        const worksheet = XLSX.utils.json_to_sheet(newThing);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        let fileNameNew = check ? "OnboardingReport" : "LearningPathReport"
        XLSX.writeFile(workbook, fileNameNew + ".xlsx");
    };
    //LP Managers
    useEffect(() => {
        if (!_.isEmpty(lpManagersRes)) {
            if (lpManagersRes?.status === "success") {
                let allData = (lpManagersRes?.payload?.payload?.managers);
                setTotalManagers(lpManagersRes?.payload?.payload)
                let temparr = _.cloneDeep(overAllManagersData)
                if (counterForMng === 1) {
                    temparr = []
                }
                setOverAllManagersData([...temparr, ...allData]);
                dispatch(getLpManagersClear())
            }
        }
    }, [lpManagersRes])

    return (
        <>
            <Loader start={isLoading} />
            <section className="reports-header pt-5 pb-2">
                <div className="container reports-head-main-filter">
                    <div className="row">
                        <div className="col-md-12">
                            <button
                                type="button"
                                id="backbtnreport"
                                className="btn btn-primary-complete bckbtn mb-3"
                                onClick={() => {
                                    navigate(-1)
                                }}
                            >
                                Back
                            </button>
                            <div className="reports-head-main">
                                Reports
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="agent-user-detailbox">
                                <div className="agent-img">
                                    <img src={_.isEmpty(officeDetail?.profile_img) ? "/images/avatar.svg" : officeDetail?.profile_img} width="96" height="96" className="img-fluid" alt="" />
                                </div>
                                <div className="agent-detsils d-flex flex-column h-100">
                                    <div className="h-50">
                                        <div class="agent-name-rsp">
                                            {officeDetail?.username}
                                        </div>
                                        <div className="agent-desg">
                                            {officeDetail?.designation}
                                        </div>
                                    </div>
                                    <div className="d-flex h-50 align-items-end">
                                        <div className="applied-filter-agentss">
                                            {officeDetail?.office_name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-page-title"><strong>{isCompliance === "0" ? "Learning Path Report" : "Onboarding Report"}</strong></div>
                </div>
            </section>


            {false && <section className="onboarding-report">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 selctdrop-report">
                            <div className="progess-report-title">Compliance Report</div>
                        </div>
                    </div>
                </div>
            </section>}



            <ReportGraphComponent
                trendYear={trendYear}
                loadChart={loaderChart}
                seriesAll={seriesOfAll}
                legendsAll={legendOfAll}
                trendValues={crsCompltTrendValues}
                listingData={courseList}
                seriesSingle={seriesOfSingle}
                legendsSingle={legendOfSingle}
                trendLoadChart={trendLoaderChart}
                filterYearData={filterYearData}
                trendFilterCourses={trendFilterCourses}
                overAllLearningPoints={overAllLearningPoints}
                trendValueSingle={crsCompltTrendValuesOfSingle}
                setYear={setTrendYear}
                setLoadChart={setLoaderChart}
                setImgLoader={setImgLoader}
                getCompletionTrend={getSingleCompletionTrend}
                filterYearDataOfSingle={filterYearDataOfSingle}
                isDetail={true}
                check={check}
                ExportToExcel={ExportToExcel}
                isLp={true}
            />

            <div className="container">
                <div className="auto-adjustrow mt-4 d-flex">
                    <div className="col-4-auto">
                        <div class="progess-rpeort-content agent-learning-points">
                            <div class="proglefttext">Learning Points</div>
                            <div class="prgcounttext">{overAllLearningPoints?.learning_points ? overAllLearningPoints?.learning_points : 0}</div>
                            <div className="d-flex gap-4 justify-content-center mt-3">
                                <div className="count-col">
                                    <div class={Number(overAllLearningPoints?.week_learning_points) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"}>
                                        {overAllLearningPoints?.week_learning_points ? overAllLearningPoints?.week_learning_points : "+0%"}
                                    </div>
                                    <div className="complints-sub-text">
                                        This Week
                                    </div>
                                </div>
                                <div className="count-col">
                                    <div className={Number(overAllLearningPoints?.from_last_week_points_progress) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"}>
                                        {overAllLearningPoints?.from_last_week_points_progress ? Number(overAllLearningPoints?.from_last_week_points_progress) >= 0 ? "+" + overAllLearningPoints?.from_last_week_points_progress + "%" : overAllLearningPoints?.from_last_week_points_progress + "%" : "+0%"}<small></small>
                                    </div>
                                    <div className="complints-sub-text">
                                        From Last Week
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-4-auto">
                        <div class="progess-rpeort-content agent-learning-points">
                            <div class="proglefttext">Learning Hours</div>
                            <div class="prgcounttext">
                                {/* <p dangerouslySetInnerHTML={{
                  __html: overAllLearningPoints?.learning_hrs_val,
                }}></p> */}
                                {overAllLearningPoints?.learning_hrs_val ? overAllLearningPoints?.learning_hrs_val : 0}
                            </div>
                            <div className="d-flex gap-3 justify-content-center mt-3">
                                <div className="count-col">
                                    <div class={Number(overAllLearningPoints?.week_learning_hrs) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"}>
                                        <p dangerouslySetInnerHTML={{
                                            __html: overAllLearningPoints?.week_learning_hrs ? overAllLearningPoints?.week_learning_hrs : "+0%",
                                        }}></p>
                                    </div>
                                    <div className="complints-sub-text">
                                        This Week
                                    </div>
                                </div>
                                <div className="count-col">
                                    <div class={Number(overAllLearningPoints?.from_last_week_hrs_progress) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"} >
                                        {overAllLearningPoints?.from_last_week_hrs_progress ? Number(overAllLearningPoints?.from_last_week_hrs_progress) >= 0 ? "+" + overAllLearningPoints?.from_last_week_hrs_progress + "%" : overAllLearningPoints?.from_last_week_hrs_progress + "%" : "+0%"}<small></small>
                                    </div>
                                    <div className="complints-sub-text">
                                        From Last Week
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* <div id="myOnboard" class="center_line"></div> */}
            {false && <ReportTableSectionComp
                setSearchInput={""}
                getFilteredData={[]}
                lpName={"Learning Path"}
                isLearningPath={true}
                isView={isView}
                statusFilterData={statusFilterData}
                setCanShow={setCanShow}
                profileReports={profileReports}
                currentTableData={currentTableData}
                type={type}
                message={"Learning Paths that are assigned to users, will appear here."}
            />}


            <ProgressReportTableComponentForAgentDetail
                setSearchInput={""}
                getFilteredData={[]}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                isView={isView}
                statusFilterData={statusFilterData}
                setCanShow={setCanShow}
                profileReports={profileReports}
                currentTableData={currentTableData}
                type={type}
                message={"Courses that are assigned to users, will appear here."}
                isCompliance={true}
                searchTable={searchTable}
                fromPage={check ? 3 : 2}   // 1=course, 2= Learning Path, 3=Onboarding
            />

        </>
    );
};
export default LearningPathReportHomeReaDetailSection;
